import { Chip, ChipProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useTranslation } from "providers/i18n"

export const HighlightChip: React.FC<ChipProps> = ({ sx = {}, ...props }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { root } = theme.components?.[`HighlightChip`]?.styleOverrides || {}

  return <Chip label={t("Highlight")} sx={deepmerge(root, sx)} {...props} />
}
